export const primaryColor = "#3f51b5";
export const backgroundColor = "#C8DEF7";
